import { useEffect, useState } from 'react';
import { RestApi } from 'common/services/rest-api.service';
import { AppLoading } from 'common/components/appLoading/appLoading';
import { Chart, CHART_TYPES, Text, TOOLTIP_TYPE } from '@cyberpion/cyberpion-ui';
import { Common } from 'common/services/common.service';
import './BurnRatioOverTimeContainer.scss';

const BurnRatioOverTimeContainer = (props: any) => {
  const [chartData, setChartData] = useState<any>(null);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [chartOptions, setChartOptions] = useState<any>(null);
  const [series, setSeries] = useState<any>(null);

  const fetchAll = async () => {
    setIsLoading(true);
    const url = 'mssp/sub-account/sub-accounts-burn-ratio-graph/';
    RestApi.getData(url).subscribe((response: any) => {
      setChartData(response);
    });
  };

  useEffect(() => {
    if (!!chartData) {
      const options = {
        ...props.chartOptions,
        xAxis: {
          categories: chartData?.data[0]?.values.map((item: any) => Common.getShortDate(item.date))
        }
      };
      setChartOptions(options);

      const data = chartData?.data[0]?.values.map((item: any) => ({ ...item, y: item.value }));
      setSeries([{ data }]);
      setIsLoading(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [chartData]);

  useEffect(() => {
    fetchAll();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="BurnRatioOverTimeContainer">
      <div className="overtime-wrapper">
        {isLoading ? (
          <AppLoading />
        ) : (
          <div style={{ backgroundColor: '#FFF' }}>
            <div style={{ display: 'flex', alignItems: 'center', padding: '22px 16px' }}>
              <Text textSize={13} weight={500} family="Rubik" textColor="#5D6576">
                Burn Ratio Over Time
              </Text>
              <Text textSize={12} family="Rubik" textColor="#5D6576" style={{ paddingLeft: 8 }}>
                (Closed Action Items/Open Action Item)
              </Text>
            </div>
            <div style={{ paddingLeft: 16 }}>
              <Chart
                series={series}
                chartType={CHART_TYPES.LINE}
                tooltipType={TOOLTIP_TYPE.LINE_WITH_CHANGE}
                isTooltip={true}
                chartOptions={chartOptions}
              />
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default BurnRatioOverTimeContainer;
